import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { ProductContext } from "../App";
import AddPayment from "../components/popups/AddPayment";
import EditAccount from "../components/popups/EditAccount";
import EditPayment from "../components/popups/EditPayment";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

function Account() {
  const product_context = useContext(ProductContext);
  const { alert, setAlert, setIsLoading, confirmDialogue, setConfirmDialogue } =
    product_context;

  const [difference, setDifference] = useState(0);
  const [pendingCash, setPendingCash] = useState(0);
  const [totalInHand, setTotalInHand] = useState(0);
  const [totalStock, setTotalStock] = useState(0);
  const [account, setAccount] = useState();
  const [payment, setPayment] = useState([]);
  const [editAccount, setEditAccount] = useState({
    isOpen: false,
    account: {},
    toEdit: "",
  });
  const [addPaymnet, setAddPayment] = useState({
    isOpen: false,
    status: "",
  });
  const [editPaymnet, setEditPayment] = useState({
    isOpen: false,
    status: "",
  });

  const reload = () => {
    setIsLoading(true);
    try {
      axios
        .get(`${process.env.REACT_APP_SERVER_DOMAIN}/account`)
        .then((res) => {
          setAccount(res.data.account_data[0]);
          setPayment(res.data.payment_data);
        })
        .catch((err) => {
          setAlert({
            isOpen: true,
            message: "Something Went Wrong",
            type: "danger",
          });
        });

      setIsLoading(false);
    } catch (error) {
      setAlert({
        isOpen: true,
        message: "Something Went Wrong",
        type: "danger",
      });
      setIsLoading(false);
    }
    setTimeout(() => {
      setAlert({ ...alert, isOpen: false });
    }, 5000);
  };

  useEffect(() => {
    reload();

    axios
      .get(`${process.env.REACT_APP_SERVER_DOMAIN}/products`)
      .then((res) => {
        setTotalStock(res.data.total[0].total_sum_in_hand);
      })
      .catch((err) => {
        setAlert({
          isOpen: true,
          message: "Something Went Wrong",
          type: "danger",
        });
      });
    setTimeout(() => {
      setAlert({ ...alert, isOpen: false });
    }, 5000);
    // eslint-disable-next-line
  }, []);

  const handleAmountEdit = (type) => {
    setEditAccount({
      isOpen: true,
      account: account,
      toEdit: type,
    });
  };

  const handleAddPayment = (status) => {
    setAddPayment({
      isOpen: true,
      status: status,
    });
  };

  const actualDeleteHandle = (id) => {
    setIsLoading(true);

    axios
      .delete(`${process.env.REACT_APP_SERVER_DOMAIN}/payment/${id}`)
      .then((res) => {
        setAlert({
          isOpen: true,
          message: "Product Deleted",
          type: "success",
        });
        reload();
      })
      .catch((err) => {
        setAlert({
          isOpen: true,
          message: "Something went wrong",
          type: "danger",
        });
      });
    setIsLoading(false);

    setTimeout(() => {
      setAlert({ ...alert, isOpen: false });
    }, 5000);
    setConfirmDialogue({ ...confirmDialogue, isOpen: false });
  };

  const handleDeletePayment = (pay) => {
    setConfirmDialogue({
      isOpen: true,
      message: "Are you sure you want to delete this payment",
      submitHandle: () => {
        actualDeleteHandle(pay._id);
      },
    });
  };

  useEffect(() => {
    let pending_cash = 0;
    payment
      ?.filter((el) => el.status === "to_receive")
      ?.forEach((el) => {
        pending_cash += Number(el?.amount || 0);
      });
    setPendingCash(pending_cash);

    let total_in_hand =
      Number(account?.zishan?.amount || 0) +
      Number(account?.shadab?.amount || 0) +
      Number(account?.delivery_portals || 0) +
      Number(account?.thrift_and_additionals || 0) +
      Number(account?.india_pending_delivery || 0) +
      pending_cash +
      Number(totalStock);

    let difference =
      total_in_hand - Number(account?.total_invested?.amount || 0);

    setDifference(difference);

    setTotalInHand(total_in_hand);
    // eslint-disable-next-line
  }, [account, totalStock]);

  return (
    <div>
      <EditAccount
        editAccount={editAccount}
        setEditAccount={setEditAccount}
        reload={reload}
      />

      <AddPayment
        addPaymnet={addPaymnet}
        setAddPayment={setAddPayment}
        reload={reload}
      />

      <EditPayment
        editPaymnet={editPaymnet}
        setEditPayment={setEditPayment}
        reload={reload}
      />

      <h3 className="text-center my-3">Accounts</h3>

      <div className="container">
        <div className="account-contents action">
          <p>Total Invested: </p>
          <p className="content mx-3">{account?.total_invested?.amount}</p>
          <EditIcon
            className="fa-solid fa-file-pen mx-2 edit"
            onClick={() => {
              handleAmountEdit("total_invested");
            }}
          ></EditIcon>
          <select className="select-log" name="" id="">
            <option value="">Log</option>
            {account?.total_invested?.updated_date?.map((details, i) => {
              return (
                <option key={i}>
                  {details?.date?.split("T")[0]} - {details?.amount}
                </option>
              );
            })}
          </select>
        </div>

        <div className="account-contents">
          <p>Total Stock: </p>
          <p className="content mx-3">{totalStock}</p>
        </div>

        <hr />
        <h5 className="mb-3">Total Cash in Hand</h5>

        <div className="account-contents action">
          <p>Zishan: </p>
          <p className="content mx-3">{account?.zishan?.amount}</p>
          <EditIcon
            className="fa-solid fa-file-pen mx-2 edit"
            onClick={() => {
              handleAmountEdit("zishan");
            }}
          ></EditIcon>
          <select className="select-log" name="" id="">
            <option value="">Log</option>
            {account?.zishan?.updated_date?.map((details, i) => {
              return (
                <option key={i}>
                  {details?.date?.split("T")[0]} - {details?.amount}
                </option>
              );
            })}
          </select>
        </div>

        <div className="account-contents action">
          <p>Shadab: </p>
          <p className="content mx-3">{account?.shadab?.amount}</p>
          <EditIcon
            className="fa-solid fa-file-pen mx-2 edit"
            onClick={() => {
              handleAmountEdit("shadab");
            }}
          ></EditIcon>
          <select className="select-log" name="" id="">
            <option value="">Log</option>
            {account?.shadab?.updated_date?.map((details, i) => {
              return (
                <option key={i}>
                  {details?.date?.split("T")[0]} - {details?.amount}
                </option>
              );
            })}
          </select>
        </div>

        <div className="account-contents action">
          <p>Delivery Portals: </p>
          <p className="content mx-3">{account?.delivery_portals}</p>
          <EditIcon
            className="fa-solid fa-file-pen mx-2 edit"
            onClick={() => {
              handleAmountEdit("delivery_portals");
            }}
          ></EditIcon>
        </div>

        <div className="account-contents action">
          <p>Thrift and additionals: </p>
          <p className="content mx-3">{account?.thrift_and_additionals}</p>
          <EditIcon
            className="fa-solid fa-file-pen mx-2 edit"
            onClick={() => {
              handleAmountEdit("thrift_and_additionals");
            }}
          ></EditIcon>
        </div>

        <div className="account-contents action">
          <p>India Pending Delivery: </p>
          <p className="content mx-3">{account?.india_pending_delivery}</p>
          <EditIcon
            className="fa-solid fa-file-pen mx-2 edit"
            onClick={() => {
              handleAmountEdit("india_pending_delivery");
            }}
          ></EditIcon>
        </div>

        <div className="account-contents">
          <p>Total Pending Cash: </p>
          <p className="content mx-3">{pendingCash}</p>
        </div>

        <hr />

        <div className="account-contents">
          <p>Total In Hand: </p>
          <p className="content mx-3">{totalInHand}</p>
        </div>

        <div className="account-contents">
          <p>Difference: </p>
          <p className="content mx-3">{difference}</p>
        </div>

        <hr />

        <div className="payments mb-5">
          <table className="table-bordered mx-3 my-3">
            <thead>
              <tr>
                <th colSpan={3} className="text-center">
                  To Pay
                </th>
              </tr>
              <tr>
                <th>Name</th>
                <th>Amount</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {payment
                ?.filter((el) => el.status === "to_pay")
                ?.map((pay, i) => {
                  return (
                    <tr key={i}>
                      <td>{pay?.name}</td>
                      <td>{pay?.amount}</td>
                      <td className="action">
                        <EditIcon
                          onClick={() => {
                            setEditPayment({
                              isOpen: true,
                              payment: pay,
                            });
                          }}
                          className="fa-solid fa-file-pen mx-2 edit"
                        ></EditIcon>
                        <DeleteIcon
                          onClick={() => {
                            handleDeletePayment(pay);
                          }}
                          className="fa-solid fa-trash delete mx-2"
                        ></DeleteIcon>
                      </td>
                    </tr>
                  );
                })}

              <tr>
                <td colSpan={3} className="text-center">
                  <button
                    onClick={() => {
                      handleAddPayment("to_pay");
                    }}
                    className="btn btn-secondary"
                  >
                    Add
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <table className="table-bordered mx-3 my-3">
            <thead>
              <tr>
                <th colSpan={3} className="text-center">
                  To Receive
                </th>
              </tr>
              <tr>
                <th>Name</th>
                <th>Amount</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {payment
                ?.filter((el) => el.status === "to_receive")
                ?.map((pay, i) => {
                  return (
                    <tr key={i}>
                      <td>{pay?.name}</td>
                      <td>{pay?.amount}</td>
                      <td className="action">
                        <EditIcon
                          onClick={() => {
                            setEditPayment({
                              isOpen: true,
                              payment: pay,
                            });
                          }}
                          className="fa-solid fa-file-pen mx-2 edit"
                        ></EditIcon>
                        <DeleteIcon
                          onClick={() => {
                            handleDeletePayment(pay);
                          }}
                          className="fa-solid fa-trash delete mx-2"
                        ></DeleteIcon>
                      </td>
                    </tr>
                  );
                })}

              <tr>
                <td colSpan={3} className="text-center">
                  <button
                    onClick={() => {
                      handleAddPayment("to_receive");
                    }}
                    className="btn btn-secondary"
                  >
                    Add
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Account;
